import { defineComponent as _defineComponent } from 'vue'
import { createVNode as _createVNode, openBlock as _openBlock, createElementBlock as _createElementBlock, pushScopeId as _pushScopeId, popScopeId as _popScopeId } from "vue"

const _withScopeId = n => (_pushScopeId("data-v-c45c3548"),n=n(),_popScopeId(),n)
const _hoisted_1 = { class: "wrapper d-flex flex-row" }

import { ref } from "vue";
  import LeftSideBlock from "@/views/components/auth/LeftSideBlock.vue";
  import RightSideBlock from "@/views/components/auth/RightSideBlock.vue";
  
  
export default /*#__PURE__*/_defineComponent({
  __name: 'LoginView',
  setup(__props) {

  const isSignUp = ref(true);
  const isPrivacyPolicy = ref(false);
  const isPasswordlessLogin = ref(false);
  
  
return (_ctx: any,_cache: any) => {
  return (_openBlock(), _createElementBlock("div", _hoisted_1, [
    _createVNode(LeftSideBlock),
    _createVNode(RightSideBlock)
  ]))
}
}

})